/**
 * The day view's one polite status region (#247): what an action on a block
 * did ("Dismissed Pinecrest Law."), said to a screen reader. It lives on the
 * day view, not in the panel, because the control that did it is often gone
 * by then: a closed form, or a dismissed block's whole panel. A failure stays
 * an alert, where it happened.
 */
import { createContext, useContext } from "react";

/** Outside a day view (a component on its own in a test), says nothing. */
export const AnnounceContext = createContext<(message: string) => void>(() => undefined);

/** Says what an action did through the day view's status region. */
export function useAnnounce(): (message: string) => void {
  return useContext(AnnounceContext);
}
